import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';
import { Company, Factory } from '../production-inventory.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyFactoryService {
  constructor(private apiService: ApiService) {}

  // Companies
  listCompanies(): Observable<Company[]> {
    return this.apiService.get('companies/');
  }

  createCompany(body: { name: string; address: string }): Observable<Company> {
    return this.apiService.post('companies/', body);
  }

  updateCompany(id: string, body: Partial<{ name: string; address: string }>): Observable<Company> {
    return this.apiService.patch(`companies/${id}/`, body);
  }

  deleteCompany(id: string): Observable<void> {
    return this.apiService.delete(`companies/${id}/`);
  }

  // Factories
  listFactories(): Observable<Factory[]> {
    return this.apiService.get('factories/');
  }

  createFactory(body: { name: string; address: string }): Observable<Factory> {
    return this.apiService.post('factories/', body);
  }

  updateFactory(id: string, body: Partial<{ name: string; address: string }>): Observable<Factory> {
    return this.apiService.patch(`factories/${id}/`, body);
  }

  deleteFactory(id: string): Observable<void> {
    return this.apiService.delete(`factories/${id}/`);
  }
}
